import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import PhotoSwipeGalleryView from 'lib/images/photoswipe-gallery-view';

import ImageView from './gallery-image-view';

export class GalleryItemView extends React.Component {
    static defaultProps = {
        limit: 4,
    };

    render() {
        const { limit, length, item, altPrefix, ...rest } = this.props;
        const { onClick, src, index, image } = item;

        return (
            <FormattedMessage id='IMAGE'>
                {msg => (
                    <ImageView
                        src={src}
                        image={image}
                        onClick={onClick}
                        moreImagesCount={index === limit - 1 ? length - limit : 0}
                        alt={`${altPrefix}${msg} č. ${index + 1}`}
                        {...rest}
                    />
                )}
            </FormattedMessage>
        );
    }
}

class GalleryView extends React.Component {
    photoSwipeItem = item => item.photoSwipeItem();

    render() {
        const { items, limit, altPrefix = '', ...rest } = this.props;

        return (
            <PhotoSwipeGalleryView
                itemElement={<GalleryItemView altPrefix={altPrefix} length={items.length} limit={limit} />}
                photoSwipeItem={this.photoSwipeItem}
                align='left'
                limit={limit}
                items={items}
                {...rest}
            />
        );
    }
}

export default observer(GalleryView);
